export const common = {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Produktressourcen, Verkäufer & Einkaufsleitfäden',
  explore: 'AllChinaBuy Spreadsheet Erkunden',
  browseGuides: 'Einkaufsleitfäden Durchsuchen',
  buyItNow: 'Jetzt Kaufen',
  allchinabuySpreadsheet: 'AllChinaBuy Spreadsheet',
  visitMainSite: 'Hauptgeschäft Besuchen',
  searchPlaceholder: 'Produkte, Verkäufer, Versand oder Leitfäden suchen...',
  categories: 'Kategorien',
  articles: 'Artikel',
  guides: 'Leitfäden',
  reviews: 'Bewertungen',
  shipping: 'Versand',
  coupon: 'Gutschein',
  warehouse: 'Lager',
  legit: 'Ist es Seriös?',
  about: 'Über Uns',
  contact: 'Kontakt',
  faq: 'FAQ',
  privacy: 'Datenschutzrichtlinie',
  terms: 'Nutzungsbedingungen',
  disclaimer: 'Haftungsausschluss',
  home: 'Startseite',
  readMore: 'Mehr Lesen',
  relatedArticles: 'Verwandte Artikel',
  tableOfContents: 'Inhaltsverzeichnis',
  lastUpdated: 'Zuletzt Aktualisiert',
  author: 'Autor',
  share: 'Teilen',
  question: 'Eine Frage?',
  ctaMainTitle: 'Bereit zum Einkaufen?',
  ctaMainDesc: 'Besuchen Sie unser Hauptgeschäft für den vollständigen AllChinaBuy-Produktkatalog.',
  ctaMainButton: 'Zum Hauptgeschäft Gehen',
  footerDesc: 'AllChinaBuy Spreadsheet ist Ihre organisierte Ressource für AllChinaBuy-Produkte, Verkäufer, Versandleitfäden und Einkaufstipps.',
  copyright: 'Alle Rechte vorbehalten.',
  notAffiliated: 'Nicht mit AllChinaBuy verbunden. Nur informative Ressource.',
  language: 'Sprache',
  english: 'Englisch',
  french: 'Französisch',
  german: 'Deutsch',
  danish: 'Dänisch',
  breadcrumbHome: 'Startseite',
  minutesRead: 'Min. Lesezeit',
  quickLinks: 'Schnelllinks',
  resources: 'Ressourcen',
  legal: 'Rechtliches',
  scrollToTop: 'Nach oben scrollen',
  viewAll: 'Alle Anzeigen',
  allProducts: 'Alle Produkte',
  buyNow: 'Kaufen',
  productsPageTitle: 'AllChinaBuy Produkte — Schuhe, Kleidung, Accessoires & Mehr',
  productsPageDescription: 'Durchsuchen Sie über 100 verifizierte Produkte aus dem AllChinaBuy Spreadsheet. Schuhe, Kapuzenpullover, T-Shirts, Jacken, Accessoires, Taschen, Parfums und mehr mit direkten Kauflinks.',
  pageNotFound: 'Seite Nicht Gefunden',
  pageNotFoundDesc: 'Die gesuchte Seite existiert nicht.',
  featuredProducts: 'Empfohlene Produkte',
  featuredProductsDesc: 'Handverlesene Artikel aus unserem AllChinaBuy Katalog',
  viewAllProducts: 'Alle Produkte Anzeigen',
};

export const nav = {
  home: 'Startseite',
  products: 'Produkte',
  categories: 'Kategorien',
  articles: 'Artikel',
  reviews: 'Bewertungen',
  shipping: 'Versand',
  coupon: 'Gutschein',
  warehouse: 'Lager',
  legit: 'Seriös?',
  about: 'Über Uns',
};

export const hero = {
  h1: 'AllChinaBuy Spreadsheet — Produkte, Verkäufer & Einkaufsressourcen Schneller Finden',
  subtitle: 'Erkunden Sie AllChinaBuy-Ressourcen, Produkte, Verkäufer, QC-Informationen, Versandleitfäden, Bewertungen und Einkaufstipps an einem organisierten Ort.',
  ctaPrimary: 'AllChinaBuy Spreadsheet Erkunden',
  ctaSecondary: 'Einkaufsleitfäden Durchsuchen',
  searchPlaceholder: 'Produkte, Verkäufer, Versand oder Leitfäden suchen...',
};

export const categories = {
  title: 'Beliebte AllChinaBuy-Kategorien',
  subtitle: 'Durchsuchen Sie die beliebtesten Produktkategorien auf AllChinaBuy',
  shoes: 'Schuhe',
  hoodiesSweaters: 'Kapuzenpullover & Pullover',
  tshirts: 'T-Shirts',
  jackets: 'Jacken',
  pantsShorts: 'Hosen & Shorts',
  headwear: 'Kopfbedeckungen',
  sets: 'Sets',
  underwear: 'Unterwäsche',
  jersey: 'Trikots',
  accessories: 'Accessoires',
  bags: 'Taschen',
  belts: 'Gürtel',
  perfumes: 'Parfums',
  otherStuff: 'Sonstiges',
  viewAll: 'Alle Kategorien Anzeigen',
};

export const homeSections = {
  popularSearchesTitle: 'Beliebte AllChinaBuy-Suchen',
  popularSearchesDesc: 'Entdecken Sie, was Käufer gerade suchen',
  spreadsheetHubTitle: 'AllChinaBuy Spreadsheet Hub',
  spreadsheetHubDesc: 'Ihre umfassende Ressource für organisierte Produkt- und Verkäuferinformationen',
  resourcesTitle: 'Produkt- & Verkäuferressourcen',
  resourcesDesc: 'Umfassende Leitfäden, die Ihnen helfen, AllChinaBuy zu navigieren',
  reviewTitle: 'AllChinaBuy-Bewertung',
  reviewDesc: 'Ehrliche, ausführliche Bewertungen von echten Käufern und unserem Redaktionsteam',
  shippingTitle: 'AllChinaBuy-Versandkosten',
  shippingDesc: 'Vergleichen Sie Versandmethoden, Linien, Zeiten und Kosten für Ihre Region',
  couponTitle: 'Gutschein & Rabattcode',
  couponDesc: 'Neueste verifizierte Gutscheine, Rabattcodes und Angebote für AllChinaBuy',
  warehouseTitle: 'Lagerleitfaden',
  warehouseDesc: 'Verstehen Sie, wie AllChinaBuy-Lager funktionieren, und optimieren Sie Ihre Lagerung',
  legitTitle: 'Ist AllChinaBuy Seriös?',
  legitDesc: 'Sicherheitsleitfaden, Vertrauensanalyse und Betrugserkennung für AllChinaBuy-Käufer',
  comparisonTitle: 'Vergleichstabellen',
  comparisonDesc: 'Sehen Sie, wie AllChinaBuy im Vergleich zu anderen Einkaufsagenturen abschneidet',
  articlesTitle: 'Neueste Artikel',
  articlesDesc: 'Frische Leitfäden, Tipps und Einblicke für AllChinaBuy-Käufer',
  faqTitle: 'Häufig Gestellte Fragen',
  faqDesc: 'Schnelle Antworten auf häufige AllChinaBuy-Fragen',
  finalCtaTitle: 'Starten Sie Ihre AllChinaBuy-Reise',
  finalCtaDesc: 'Besuchen Sie unser Hauptgeschäft für den vollständigen Katalog und die neuesten Angebote.',
  finalCtaButton: 'Hauptgeschäft Besuchen',
};

export const articles = {
  allchinabuySpreadsheetGuide: 'AllChinaBuy Spreadsheet-Leitfaden: Vollständiges Produkt- & Verkäuferverzeichnis 2026',
  allchinabuySpreadsheetGuideDesc: 'Der umfassendste Leitfaden zur Verwendung von AllChinaBuy Spreadsheets. Lernen Sie, Produkte, Verkäufer, QC-Fotos und Versandinformationen schneller zu finden.',
  allchinabuyReview2026: 'AllChinaBuy-Bewertung 2026: Funktionen, Versand & Einkaufsleitfaden',
  allchinabuyReview2026Desc: 'Eine ehrliche Bewertung der AllChinaBuy-Funktionen, Vor- und Nachteile, Versand und Einkaufserfahrung. Aktualisiert für 2026.',
  allchinabuyShippingCost: 'AllChinaBuy-Versandkosten: Vollständiger Leitfaden & Vergleich',
  allchinabuyShippingCostDesc: 'Vergleichen Sie Versandlinien, Kosten, Lieferzeiten und Zolltipps für AllChinaBuy-Bestellungen.',
  allchinabuyCoupon: 'AllChinaBuy-Gutschein & Rabattcode: Leitfaden für die Neuesten Angebote',
  allchinabuyCouponDesc: 'Finden Sie die neuesten verifizierten AllChinaBuy-Gutscheine, Rabattcodes und Werbeaktionen.',
  allchinabuyWarehouseGuide: 'AllChinaBuy-Lagerleitfaden: Lagerung, QC & Versand',
  allchinabuyWarehouseGuideDesc: 'Alles, was Sie über AllChinaBuy-Lager, Lagerung und Qualitätskontrolle wissen müssen.',
  isAllchinabuyLegit: 'Ist AllChinaBuy Seriös? Sicherheits- & Vertrauensleitfaden 2026',
  isAllchinabuyLegitDesc: 'Sicherheitsanalyse, Vertrauensindikatoren, Betrugserkennung und Tipps für sicheren Einkauf bei AllChinaBuy.',
  allchinabuyVsSuperbuy: 'AllChinaBuy vs Superbuy: Detaillierter Vergleich 2026',
  allchinabuyVsSuperbuyDesc: 'Vergleich von AllChinaBuy und Superbuy Funktionen, Versand, QC und Preisgestaltung.',
  allchinabuyBeginnerGuide: 'AllChinaBuy-Anfängerleitfaden: Schritt-für-Schritt Einkaufen',
  allchinabuyBeginnerGuideDesc: 'Neu bei AllChinaBuy? Dieser Schritt-für-Schritt-Leitfaden begleitet Sie von der Registrierung bis zum Versand.',
};

export const articleContent = {
  spreadsheetGuideTitle: 'AllChinaBuy Spreadsheet-Leitfaden: Vollständiges Produkt- & Verkäuferverzeichnis 2026',
  spreadsheetGuideIntro: 'AllChinaBuy ist zu einem der beliebtesten Einkaufsagenten für internationale Käufer geworden, die Produkte auf chinesischen Marktplätzen suchen. Ob Sie nach Sneakern, Streetwear, Accessoires oder Nischenfunden suchen, das AllChinaBuy-Spreadsheet-Ökosystem hilft Ihnen, Produktlinks, Verkäuferinformationen, QC-Fotos und Preise an einem Ort zu organisieren. Dieser Leitfaden ist die umfassendste Ressource, um zu verstehen, wie Sie AllChinaBuy Spreadsheets nutzen können, um intelligenter einzukaufen, Geld zu sparen und häufige Fehler zu vermeiden.',
  whatIsSpreadsheetTitle: 'Was ist ein AllChinaBuy Spreadsheet?',
  whatIsSpreadsheetContent: 'Ein AllChinaBuy Spreadsheet ist ein kuratiertes Dokument oder eine Datenbank, die organisierte Links zu Produkten, Verkäufern und Einkaufsressourcen auf AllChinaBuy enthält. Diese Spreadsheets können Kategorien wie Schuhe, Kleidung, Accessoires, Taschen und mehr enthalten. Sie enthalten oft Produktnamen, Verkäufernamen, Preise, QC-Foto-Links, Größentabellen und direkte Kauflinks. Das Ziel ist es, Käufern Zeit zu sparen, indem eine strukturierte Möglichkeit zum Durchsuchen und Vergleichen von Produkten geboten wird.',
  whyUseSpreadsheetTitle: 'Warum AllChinaBuy Spreadsheets Verwenden?',
  whyUseSpreadsheetContent1: 'Zeit sparen — Spreadsheets geben direkte Links zu kuratierten Produkten und vertrauenswürdigen Verkäufern.',
  whyUseSpreadsheetContent2: 'Preise vergleichen — Sehen Sie Preise für ähnliche Produkte bei verschiedenen Verkäufern auf einen Blick.',
  whyUseSpreadsheetContent3: 'QC-Fotos — Viele Spreadsheets enthalten Links zu Qualitätskontrollfotos.',
  whyUseSpreadsheetContent4: 'Vertrauenswürdige Verkäufer — Kuratierte Spreadsheets zeigen Verkäufer mit guten Bewertungen.',
  whyUseSpreadsheetContent5: 'Community-gestützt — Die besten Spreadsheets werden von Käufer-Communities gepflegt.',
  howToUseSpreadsheetTitle: 'Wie Man ein AllChinaBuy Spreadsheet Verwendet',
  howToUseSpreadsheetContent: 'Die Verwendung eines AllChinaBuy Spreadsheets ist unkompliziert. Identifizieren Sie zuerst die Kategorie, die Sie interessiert — Schuhe, Pullover, Accessoires. Öffnen Sie das Spreadsheet und durchsuchen Sie den relevanten Tab. Jede Zeile enthält normalerweise den Produktnamen, Verkäufer, Preis und einen Link. Klicken Sie auf den Link, um das Produkt auf dem Marktplatz anzusehen. Überprüfen Sie vor dem Kauf, ob QC-Fotos verfügbar sind, und lesen Sie die Notizen des Kurators. Fügen Sie das Produkt zu Ihrem AllChinaBuy-Warenkorb hinzu, senden Sie den Kauf ab und warten Sie auf die Ankunft im Lager. Überprüfen Sie die QC-Fotos und genehmigen oder fordern Sie eine Rücksendung an.',
  popularCategoriesTitle: 'Beliebte AllChinaBuy Spreadsheet-Kategorien',
  popularCategoriesContent: 'Die beliebtesten Kategorien in AllChinaBuy Spreadsheets umfassen Schuhe und Sneaker, Kapuzenpullover und Pullover, T-Shirts, Jacken, Hosen und Shorts, Kopfbedeckungen, Accessoires, Taschen, Gürtel und Parfums. Jede Kategorie hat ihre eigenen vertrauenswürdigen Verkäufer und Produktpaletten.',
  spreadsheetTipsTitle: 'Tipps für die Optimale Nutzung von Spreadsheets',
  spreadsheetTipsContent1: 'Überprüfen Sie immer die Verkäuferreputation vor dem Kauf — sehen Sie sich Bewertungen und aktuelles Feedback an.',
  spreadsheetTipsContent2: 'Vergleichen Sie Preise über mehrere Spreadsheets — verschiedene Kuratoren haben möglicherweise unterschiedliche Angebote.',
  spreadsheetTipsContent3: 'Treten Sie Communities bei — Discord-Server, Reddit-Foren und Telegram-Gruppen teilen oft die aktuellsten Spreadsheets.',
  spreadsheetTipsContent4: 'Überprüfen Sie QC-Fotos sorgfältig — was Sie im Spreadsheet sehen, kann sich leicht vom Endprodukt unterscheiden.',
  spreadsheetTipsContent5: 'Speichern Sie Ihre Lieblingsspreadsheets — bookmarken Sie sie, um auf Updates und neue Funde zu prüfen.',
  comparisonTitle: 'AllChinaBuy vs Andere Einkaufsagenturen',
  comparisonContent: 'Beim Vergleich von AllChinaBuy mit anderen Agenturen wie Superbuy, CSSBuy, Sugargoo und Basetao hat jede Plattform ihre Stärken. AllChinaBuy ist beliebt für seinen spreadsheet-freundlichen Ansatz und Community-Sharing. Superbuy bietet poliertere Software und Kundensupport. CSSBuy ist bekannt für wettbewerbsfähige Versandraten. Sugargoo hat eine benutzerfreundliche Oberfläche. Basetao bietet einen älteren, aber zuverlässigen Service. Für Spreadsheet-Nutzer wird AllChinaBuy oft bevorzugt, da seine Community aktiv Listen teilt und pflegt.',
  faqQuestion1: 'Sind AllChinaBuy Spreadsheets kostenlos?',
  faqAnswer1: 'Ja, die meisten AllChinaBuy Spreadsheets sind kostenlos und von Community-Mitgliedern geteilt. Einige Kuratoren bieten möglicherweise Premium-Spreadsheets mit exklusiven Funden für eine kleine Gebühr an.',
  faqQuestion2: 'Wie oft werden Spreadsheets aktualisiert?',
  faqAnswer2: 'Das hängt vom Kurator ab. Aktive Community-Spreadsheets werden wöchentlich oder monatlich aktualisiert. Überprüfen Sie immer das letzte Aktualisierungsdatum.',
  faqQuestion3: 'Kann ich allen Verkäufern in einem Spreadsheet vertrauen?',
  faqAnswer3: 'Nicht alle Verkäufer sind gleich zuverlässig. Reputable Spreadsheets enthalten normalerweise Hinweise zur Verkäuferqualität. Überprüfen Sie immer aktuelle Bewertungen und QC-Fotos.',
  faqQuestion4: 'Was soll ich tun, wenn ein Produktlink defekt ist?',
  faqAnswer4: 'Wenn ein Produktlink defekt ist, suchen Sie direkt auf dem Marktplatz nach dem Produkt- oder Verkäufernamen. Sie können auch den Kurator oder die Community um einen aktualisierten Link bitten.',
  conclusionTitle: 'Fazit',
  conclusionContent: 'AllChinaBuy Spreadsheets sind ein unschätzbares Werkzeug für internationale Käufer, die Zeit sparen, Produkte vergleichen und mit Vertrauen einkaufen möchten. Durch die Verwendung kuratierter Spreadsheets können Sie auf vertrauenswürdige Verkäufer, QC-Fotos und organisierte Produktkategorien an einem Ort zugreifen. Ob Anfänger oder erfahrener Käufer, dieser Leitfaden gibt Ihnen alles, was Sie brauchen, um AllChinaBuy Spreadsheets im Jahr 2026 effektiv zu nutzen.',
  backToHome: 'Zurück zur Startseite',
  nextArticle: 'Nächster Artikel',
  prevArticle: 'Vorheriger Artikel',
  writtenBy: 'Geschrieben von',
  publishedOn: 'Veröffentlicht am',
  updatedOn: 'Aktualisiert am',
  readingTime: 'Lesezeit',
};

export default {
  ...common,
  ...nav,
  ...hero,
  ...categories,
  ...homeSections,
  ...articles,
  ...articleContent,
};